export function setElHeight(el) {
    let maxHeight = 0

    el.forEach( item => {
        if ( item.clientHeight > maxHeight )
            maxHeight = item.clientHeight
    })

    el.forEach( item => {
        item.style.height = maxHeight + 'px'
    })
}

export function throttle(fn, wait) {
    let time = Date.now()
    return function() {
        if ( (time + wait - Date.now()) < 0 ) {
            fn()
            time = Date.now()
        }
    }
}